import { put, takeLatest, select, take, call } from 'redux-saga/effects';
import types from './types';
import actions from './actions';
import ktRequest from '../../../utils/request';
import moment from 'moment';
import { Auth } from 'aws-amplify';

const getRooms = state => state.rooms.rooms;
const getCurrentCenterId = state => state.identity.centerId;

function * getRoomIds () {
  let rooms = yield select(getRooms);

  if (rooms.length === 0) {
    yield put({ type: 'FETCH_ROOMS' });
    yield take('FETCH_ROOMS_SUCCESS');

    rooms = yield select(getRooms);
  }

  return rooms.map(room => room.id);
}

function * getMenus (payload) {
  try {
    // make sure there are rooms in redux
    yield call(getRoomIds);
    const currentCenterId = yield select(getCurrentCenterId);
    const response = yield ktRequest.get(`menus?centerId=${currentCenterId}`, 'menus');
    const { menus } = response;
    const menusArr = menus.map(menu => {
      const { entities } = menu;
      const isCenterMenu = entities.map(entity => entity.type).includes('center');

      return {
        ...menu,
        menuType: isCenterMenu ? 'Center' : 'Room'
      };
    });
    yield put(actions.getMenusSuccess(menusArr));
  } catch (error) {
    yield put(actions.getMenusFailure(error));
  }
}

function * copyMenu (payload) {
  try {
    const { menuToCopy, datesToCopyTo } = payload;
    const { meals, entities, menuName } = menuToCopy;
    const currentCenterId = yield select(getCurrentCenterId);

    const body = {
      entities,
      meals,
      name: menuName,
      dates: datesToCopyTo,
      centerId: currentCenterId
    };

    yield ktRequest.post('menus', body, 'menus');
    yield call(getMenus);
    yield put(actions.copyMenuSuccess());
  } catch (error) {
    console.log(error);
    yield put(actions.copyMenuFailure());
  }
}

function * archiveMenu (payload) {
  try {
    const { menuId } = payload;
    const body = { menuId };
    const response = yield ktRequest.post(`menus/${menuId}/archive`, body, 'menus');

    if (!response.ok) {
      throw new Error('Error trying to archive menu');
    }

    yield put(actions.archiveMenuSuccess(menuId));
  } catch (error) {
    yield put(actions.archiveMenuFailure());
  }
}

function * printMenusForMonth (payload) {
  try {
    document.body.style.cursor = 'progress';

    const currentSession = yield Auth.currentSession();
    const jwt = currentSession.idToken.jwtToken;
    const centerId = yield select(getCurrentCenterId);
    const currentMonth = moment().month();
    const baseUrl = process.env.REACT_APP_STAGE === 'dev' ? 'https://menu-dev.kangarootime.com/api' : 'https://menu.kangarootime.com/api';
    const html = yield fetch(`${baseUrl}/menus/export?centerId=${centerId}&month=${currentMonth}`, {
      method: 'GET',
      headers: {
        Authorization: jwt,
        'Content-Type': 'text/html'
      }
    }).then(res => res.text());

    document.body.style.cursor = 'default';

    const newWindow = window.open('', '_blank');
    newWindow.document.write(html);
    newWindow.print();
  } catch (error) {
    console.log(error);
  }
}

export const menusSagas = [
  takeLatest(types.GET_MENUS_REQUEST, getMenus),
  takeLatest(types.COPY_MENU_REQUEST, copyMenu),
  takeLatest(types.ARCHIVE_MENU_REQUEST, archiveMenu),
  takeLatest(types.PRINT_MENUS_FOR_CURRENT_MONTH, printMenusForMonth)
];
